'use client'
import { clsx } from 'clsx'
import * as React from 'react'

type LogoProps = Omit<React.JSX.IntrinsicElements['svg'], 'ref'> & {
  variant?: 'mark' | 'full' | 'circle'
}

export const BaseLogo = React.forwardRef<SVGSVGElement, LogoProps>(
  ({ variant = 'full', ...svgProps }, ref) => {
    const id = React.useId()

    return (
      <svg
        {...svgProps}
        ref={ref}
        viewBox={`0 0 ${variant === 'full' ? 102 : 23} 31`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>BaseHub Logo</title>
        {variant === 'full' && (
          <>
            <path
              d="M31.3887 21.8967H35.5485C38.0622 21.8967 39.8323 20.4275 39.8323 18.3387C39.8323 16.781 38.6994 15.6304 37.0355 15.4003C38.3454 15.1347 39.3013 14.0903 39.3013 12.8158C39.3013 10.6739 37.5842 9.32861 34.8405 9.32861H31.3887V21.8967ZM32.9464 20.3744V16.2676H35.5485C37.1063 16.2676 38.2038 17.0642 38.2038 18.3387C38.2038 19.5955 37.1063 20.3744 35.5485 20.3744H32.9464ZM32.9464 14.7453V10.8509H34.8405C36.5752 10.8509 37.6727 11.6121 37.6727 12.8158C37.6727 14.0018 36.5752 14.7453 34.8405 14.7453H32.9464Z"
              fill="var(--color-bright)"
            />
            <path
              d="M43.192 19.4008C43.192 18.0555 44.3249 18.0732 45.7057 17.8077L47.9007 17.4005V18.0201C47.9007 19.7548 46.6969 20.7638 45.1746 20.8346C43.8116 20.9054 43.192 20.1266 43.192 19.4008ZM41.5989 19.4008C41.5989 21.0825 43.1212 22.0737 44.9799 22.1091C46.4491 22.0737 47.5466 21.3126 47.9538 20.4629L48.0069 21.8967H49.3876V16.2322C49.3876 13.6124 47.8652 12.3025 45.5994 12.3025C43.6523 12.3025 42.1299 13.4885 41.7582 15.2763L43.4045 15.4003C43.6346 14.4444 44.4665 13.754 45.5994 13.754C46.9625 13.754 47.8475 14.5152 47.8652 16.0729L45.1392 16.5686C43.0681 16.9403 41.5989 17.4182 41.5989 19.4008Z"
              fill="var(--color-bright)"
            />
            <path
              d="M57.5025 15.418L59.0249 15.3117C58.7239 13.4885 57.2193 12.3025 55.2544 12.3025C53.3426 12.3025 51.6433 13.3646 51.6433 15.2763C51.6433 17.0111 53.4843 17.6129 55.1836 18.0201C56.1749 18.2502 57.4848 18.3918 57.4848 19.4185C57.4848 20.4098 56.405 20.6576 55.4137 20.6576C54.1215 20.6576 53.1125 19.9496 52.9178 18.8344L51.3424 18.9406C51.484 20.8877 53.2541 22.1091 55.4137 22.1091C57.2547 22.1091 59.078 21.348 59.078 19.507C59.078 17.7015 57.2016 17.135 55.4491 16.6925C54.4578 16.4269 53.2364 16.2145 53.2364 15.1878C53.2364 14.2319 54.1392 13.754 55.0951 13.754C56.2811 13.754 57.2901 14.3736 57.5025 15.418Z"
              fill="var(--color-bright)"
            />
            <path
              d="M64.7885 22.1091C66.5941 22.1091 68.1872 21.0116 68.736 19.2415L67.1074 19.1176C66.6826 20.0912 65.7798 20.6576 64.7885 20.6576C63.1954 20.6576 62.2395 19.5601 62.0979 17.6838H68.8776V17.0288L68.8599 16.9934C68.7006 13.6301 66.8419 12.3025 64.7885 12.3025C62.1864 12.3025 60.487 14.2142 60.487 17.2058C60.487 20.1974 62.1864 22.1091 64.7885 22.1091ZM62.1333 16.3384C62.3811 14.7099 63.3193 13.754 64.7885 13.754C65.9037 13.754 66.9481 14.3913 67.2136 16.3384H62.1333Z"
              fill="var(--color-bright)"
            />
            <path
              d="M70.7332 21.8967H72.2909V16.3384H78.0263V21.8967H79.584V9.32861H78.0263V14.8161H72.2909V9.32861H70.7332V21.8967Z"
              fill="var(--color-bright)"
            />
            <path
              d="M89.4199 21.8967V12.5149H87.8975V18.1086C87.8975 19.8433 86.9239 20.7638 85.4901 20.7638C84.1448 20.7638 83.5783 19.8433 83.5783 18.1086V12.5149H82.056V18.5511C82.056 20.5337 83.0827 22.1091 85.1715 22.1091C86.3929 22.1091 87.4727 21.5604 87.9683 20.3567V21.8967H89.4199Z"
              fill="var(--color-bright)"
            />
            <path
              d="M91.7735 9.32861V21.8967H93.1543L93.2074 20.5868C93.7207 21.5427 94.712 22.1091 96.1635 22.1091C98.8896 22.1091 100.129 19.7725 100.129 17.2058C100.129 14.6391 98.8896 12.3025 96.1635 12.3025C94.7828 12.3025 93.8269 12.7981 93.2959 13.7186V9.32861H91.7735ZM93.1543 17.2058C93.1543 15.4003 93.9154 13.6832 95.8449 13.6832C97.7921 13.6832 98.5355 15.3825 98.5355 17.2058C98.5355 18.9583 97.7921 20.6576 95.8449 20.6576C93.9154 20.6576 93.1543 18.9406 93.1543 17.2058Z"
              fill="var(--color-bright)"
            />
          </>
        )}

        <g clipPath={`url(#clip-${id})`}>
          <rect
            y="0.90625"
            width="22.7813"
            height="29.4375"
            rx="4.6875"
            fill="var(--color-bg)"
          />
          <rect
            width="44.6311"
            height="2.374"
            transform="matrix(0.707108 -0.707105 0.707108 0.707105 8.07422 37.1143)"
            fill="var(--color-accent)"
            fillOpacity="0.6"
          />
          <rect
            opacity="0.5"
            width="44.6311"
            height="2.374"
            transform="matrix(0.707108 -0.707105 0.707108 0.707105 8.07422 33.7915)"
            fill="var(--color-accent)"
          />
          <rect
            opacity="0.4"
            width="44.6311"
            height="2.374"
            transform="matrix(0.707108 -0.707105 0.707108 0.707105 4.74902 33.7915)"
            fill="var(--color-accent)"
          />
          <rect
            opacity="0.35"
            width="44.6311"
            height="2.374"
            transform="matrix(0.707108 -0.707105 0.707108 0.707105 1.4248 33.7915)"
            fill="var(--color-accent)"
          />
          <rect
            opacity="0.3"
            width="44.6311"
            height="2.374"
            transform="matrix(0.707108 -0.707105 0.707108 0.707105 0.475586 31.417)"
            fill="var(--color-accent)"
          />
          <rect
            opacity="0.25"
            width="44.6311"
            height="2.374"
            transform="matrix(0.707108 -0.707105 0.707108 0.707105 0.000976562 28.5684)"
            fill="var(--color-accent)"
          />
          <rect
            opacity="0.2"
            width="44.6311"
            height="2.374"
            transform="matrix(0.707108 -0.707105 0.707108 0.707105 -1.42383 26.6689)"
            fill="var(--color-accent)"
          />
          <rect
            opacity="0.15"
            width="44.6311"
            height="2.374"
            transform="matrix(0.707108 -0.707105 0.707108 0.707105 -4.74707 26.6689)"
            fill="var(--color-accent)"
          />
          <rect
            opacity="0.1"
            width="44.6311"
            height="2.374"
            transform="matrix(0.707108 -0.707105 0.707108 0.707105 -8.07129 26.6689)"
            fill="var(--color-accent)"
          />
        </g>
        <rect
          x="0.712199"
          y="1.61845"
          width="21.3569"
          height="28.0131"
          rx="3.9753"
          stroke="var(--color-accent)"
          strokeWidth="1.4244"
        />
        <defs>
          <clipPath id={`clip-${id}`}>
            <rect
              y="0.90625"
              width="22.7813"
              height="29.4375"
              rx="4.6875"
              fill="white"
            />
          </clipPath>
        </defs>
      </svg>
    )
  }
)

export const Logo = React.forwardRef<SVGSVGElement, LogoProps>(
  ({ variant = 'full', height, width, className, ...svgProps }, ref) => {
    if (variant === 'circle') {
      width = width ?? 16
      height = height ?? 16
      const logoWidth = Number(width) * 1.25
      return (
        <div
          style={{ width, height }}
          className={clsx(
            'border border-dark-control-base rounded-full overflow-hidden relative',
            className
          )}
        >
          <BaseLogo
            ref={ref}
            variant="mark"
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            width={logoWidth}
            {...svgProps}
          />
        </div>
      )
    }

    return (
      <BaseLogo
        ref={ref}
        variant={variant}
        className={className}
        width={width}
        height={height}
        {...svgProps}
      />
    )
  }
)
